/* Listicle section kit — reveal on scroll, sticky CTA, video facades.
   Idempotent: safe to run again after a section re-renders in the editor. */
(function () {
  'use strict';

  function reveal(root) {
    var els = (root || document).querySelectorAll('.lst-rv:not([data-lst-rv])');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-lst-rv', '');
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.06 }
    );

    els.forEach(function (el) {
      el.setAttribute('data-lst-rv', '');
      io.observe(el);
    });
  }

  function sticky(root) {
    var bars = (root || document).querySelectorAll('.lst-sticky:not([data-lst-sticky])');
    bars.forEach(function (bar) {
      bar.setAttribute('data-lst-sticky', '');
      var after = parseInt(bar.getAttribute('data-show-after') || '70', 10) / 100;

      var toggle = function () {
        bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * after);
      };

      window.addEventListener('scroll', toggle, { passive: true });
      window.addEventListener('resize', toggle, { passive: true });
      toggle();
    });
  }

  function videos(root) {
    var cards = (root || document).querySelectorAll('.lst-vid-poster:not([data-lst-video])');
    cards.forEach(function (card) {
      card.setAttribute('data-lst-video', '');
      var button = card.querySelector('.lst-play');
      if (!button) return;

      button.addEventListener('click', function () {
        var video = card.querySelector('video');
        var embed = card.getAttribute('data-embed');

        if (video) {
          card.classList.add('is-playing');
          video.setAttribute('controls', 'controls');
          var playing = video.play();
          if (playing && typeof playing.catch === 'function') playing.catch(function () {});
          return;
        }

        if (embed) {
          var frame = document.createElement('iframe');
          frame.src = embed;
          frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          frame.setAttribute('allowfullscreen', '');
          frame.setAttribute('title', card.getAttribute('data-embed-title') || 'Customer review video');
          card.classList.add('is-playing');
          card.appendChild(frame);
        }
      });
    });
  }

  function init(root) {
    reveal(root);
    sticky(root);
    videos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-bind when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  window.listicleInit = init;
})();
